function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-mail"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "mail",
  clipPath: "url(#clip-mail)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M17.417,3.667H4.583a2.75,2.75,0,0,0-2.75,2.75v9.167a2.75,2.75,0,0,0,2.75,2.75H17.417a2.75,2.75,0,0,0,2.75-2.75V6.417A2.75,2.75,0,0,0,17.417,3.667ZM16.8,5.5,11,9.854,5.2,5.5Zm.614,11H4.583a.917.917,0,0,1-.917-.917V6.646l6.783,5.087a.916.916,0,0,0,1.1,0l6.783-5.087v8.937A.917.917,0,0,1,17.417,16.5Z",
  transform: "translate(-1 -1)",
  fill: "#2e5bff"
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.f28662f7.svg";
export { ForwardRef as ReactComponent };